<template>
  <div class="max-w-4xl mx-auto">
    <Head title="Editar Caja Registradora" />

    <!-- Header -->
    <div class="flex items-center gap-4 mb-8">
      <button
        class="p-3 text-white bg-teal-700 hover:bg-teal-800 rounded-lg transition-colors"
        title="Volver atrás"
        @click="back()"
      >
        <i class="fa fa-arrow-left"></i>
      </button>
      <h1 class="text-3xl font-bold">
        <Link
          class="text-teal-600 hover:text-teal-700 transition-colors"
          href="/cash-registers"
        >
          Cajas Registradoras
        </Link>
        <span class="text-gray-400 font-medium mx-2">/</span>
        <span>Editar</span>
      </h1>
    </div>

    <!-- Form -->
    <div class="max-w-4xl bg-white rounded-lg shadow-sm border border-gray-200">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Nombre de la caja"
          />

          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            class="pb-8 pr-6 w-full"
            label="Descripción"
            rows="3"
          />

          <!-- Status Info -->
          <div class="pb-8 pr-6 w-full">
            <label class="block text-gray-700 mb-2">Estado actual</label>
            <div class="flex items-center gap-2">
              <span
                :class="getStatusClass(cashRegister.status)"
                class="px-3 py-1 rounded-full text-sm font-medium"
              >
                {{ getStatusText(cashRegister.status) }}
              </span>
              <span class="text-sm text-gray-500">
                {{ cashRegister.status === 'open' ? 'Caja abierta' : 'Caja cerrada' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="px-6 py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-lg transition-colors"
            type="submit"
          >
            Actualizar caja
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    TextareaInput
  },

  layout: Layout,

  props: {
    cashRegister: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        name: this.cashRegister.name,
        description: this.cashRegister.description,
      }),
    }
  },

  methods: {
    back() {
      window.history.back()
    },

    getStatusClass(status) {
      return {
        'open': 'bg-green-100 text-green-800',
        'closed': 'bg-red-100 text-red-800',
      }[status] || 'bg-gray-100 text-gray-800'
    },

    getStatusText(status) {
      return {
        'open': 'Abierta',
        'closed': 'Cerrada',
      }[status] || 'Desconocido'
    },

    update() {
      this.form.put(`/cash-registers/${this.cashRegister.id}`)
    },
  }
}
</script>